import type { PublicItem } from '@im-marina/shared';

/** Lightbox state lives in the URL: `?item=<slug>&i=<index>`. */
export type LightboxState = { item: PublicItem; index: number } | null;

export function readLightboxState(params: URLSearchParams, items: PublicItem[]): LightboxState {
  const slug = params.get('item');
  if (!slug) return null;
  const item = items.find((i) => i.slug === slug);
  if (!item) return null;
  const raw = Number.parseInt(params.get('i') ?? '0', 10);
  const index = Number.isFinite(raw) ? Math.min(Math.max(raw, 0), item.media.length - 1) : 0;
  return { item, index };
}

/** Wraps around at both ends. */
export const stepIndex = (index: number, delta: number, length: number) =>
  (((index + delta) % length) + length) % length;
